import axios from 'axios';
import { Restaurant } from '../models/Restaurant';

const API_BASE_URL = '/testing/getRestaurants'; // Replace with actual API endpoint

export interface SearchParams {
  location: string;
  radius: number; // in meters
  price?: string; // comma-delimited list of prices (1,2,3,4)
  categories?: string; // comma-delimited list of categories
  limit?: number;
  open_now?: boolean;
}

export const searchRestaurants = async (params: SearchParams): Promise<Restaurant[]> => {
  try {
    // Convert radius from miles to meters (Yelp API uses meters)
    const radiusInMeters = Math.round(params.radius * 1609.34);
    
    const response = await axios.get(`${API_BASE_URL}`, {
      params: {
        ...params,
        radius: radiusInMeters,
        limit: params.limit || 20,
        open_now: params.open_now !== undefined ? params.open_now : true,
      },
    });
    
    return response.data.businesses || [];
  } catch (error) {
    console.error('Error fetching restaurants:', error);
    return [];
  }
};

export const getRestaurantById = async (id: string): Promise<Restaurant | null> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/businesses/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching restaurant with id ${id}:`, error);
    return null;
  }
};